import React from "react";
import {
  StepContent,
  ProviderCard,
  ProviderLogo,
  TypeCardTitle,
  TypeCardDesc,
  ComingSoonTag,
  DetailSectionTitle,
} from "../styles";

interface StepSelectProviderProps {
  selectedProvider: string;
  onProviderChange: (provider: string) => void;
}

const StepSelectProvider: React.FC<StepSelectProviderProps> = ({
  selectedProvider,
  onProviderChange,
}) => {
  return (
    <StepContent>
      <DetailSectionTitle>Select provider</DetailSectionTitle>
      <p>
        Choose the external provider for your existing data source. Lumina will
        connect using your credentials and register a portal reference.
      </p>

      <ProviderCard
        $selected={selectedProvider === "algolia"}
        onClick={() => onProviderChange("algolia")}
      >
        <ProviderLogo>ALG</ProviderLogo>
        <div>
          <TypeCardTitle>Algolia</TypeCardTitle>
          <TypeCardDesc>Connect an existing Algolia search index</TypeCardDesc>
        </div>
      </ProviderCard>

      <ProviderCard $disabled>
        <ProviderLogo>S3</ProviderLogo>
        <div>
          <TypeCardTitle>Amazon S3</TypeCardTitle>
          <TypeCardDesc>Connect a bucket for blob retrieval</TypeCardDesc>
          <ComingSoonTag>Coming soon</ComingSoonTag>
        </div>
      </ProviderCard>
    </StepContent>
  );
};

export default StepSelectProvider;
